import React, { useEffect, useRef, useState, useCallback } from 'react';
import { ActivityIndicator, Dimensions, Pressable, View, StyleSheet, Alert, Linking, Platform, TouchableOpacity } from 'react-native';
import { CameraPickerState, ColorTokens, FontSizeTokens, } from '@voltmoney/schema';
let RNVC, RNFS, Camera, useCameraDevices, CameraDevice;
if (Platform.OS !== 'web') {
    RNFS = require('react-native-fs');
    RNVC = require('react-native-vision-camera');
    Camera = RNVC.Camera;
    useCameraDevices = RNVC.useCameraDevices;
    CameraDevice = RNVC.CameraDevice;
}
import { getScreenType, UI_WINDOW_HEIGHT, } from '../stack/utils';
import ThemeProvider from '@voltmoney/theme';
import { Typography } from "../typography/Typography";
const windowX = Dimensions.get('window');
const screenX = Dimensions.get('screen');
const CameraPicker = ({ state = CameraPickerState.OFF, cancelAction, action, triggerAction, metaData, }) => {
    console.log("RNVC 123: ", RNVC);
    let phoneDevice;
    const [dimensions, setDimensions] = useState({
        window: windowX,
        screen: screenX,
    });
    const getBlob = useCallback((fileUri) => {
        return fetch(fileUri).then(response => {
            return response.blob();
        }, error => {
            console.log(`Error in converting image to blob - ${error}`);
        });
    }, []);
    const blobToBase64 = useCallback(blob => {
        try {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            return new Promise(resolve => {
                reader.onloadend = () => {
                    resolve(reader.result);
                };
            });
        }
        catch (err) {
            console.log(`Error in converting blob to base64 - ${err}`);
            throw err;
        }
    }, []);
    const sendImage = useCallback(async (imageUri) => {
        try {
            const blob = await getBlob(imageUri);
            blobToBase64(blob).then(finalImage => {
                console.log("SAGAR BASE 64 received is", finalImage);
            });
        }
        catch (err) {
            console.log(err);
        }
    }, [blobToBase64, getBlob]);
    const device2 = useCameraDevices();
    const device = useCameraDevices();
    //@ts-ignore
    const [cameraDevice, setDevice] = useState(device?.front);
    if (!metaData) {
        metaData.height =
            dimensions.window.height -
                UI_WINDOW_HEIGHT(getScreenType(dimensions.window.width));
    }
    const theme = ThemeProvider.getTheme();
    //@ts-ignore
    const cameraRef = useRef(null);
    const [isLoading, setLoading] = useState(false);
    const setCameraWebRef = async (ref) => {
        cameraRef.current = ref;
    };
    const handleAction = async (image) => {
        if (action && triggerAction) {
            setLoading(true);
            await triggerAction({
                ...action,
                payload: { ...action, value: image },
            });
            setLoading(false);
        }
    };
    useEffect(() => {
        console.log("GOT THE CAMERA %%%%%", cameraDevice);
        setDevice(device?.front);
    }, [device, cameraDevice]);
    useEffect(() => {
        askForCameraPermission();
    }, []);
    useEffect(() => {
        const subscription = Dimensions.addEventListener('change', ({ window, screen }) => {
            setDimensions({ window, screen });
        });
        return () => subscription?.remove();
    });
    const askForCameraPermission = async () => {
        const cameraPermission = await Camera.requestCameraPermission();
        if (cameraPermission === 'denied') {
            Alert.alert('This feature requires camera access', 'In iPhone settings, tap voltmoney and turn on camera', [
                {
                    text: 'Cancel',
                    onPress: () => { },
                    style: 'cancel',
                },
                {
                    text: 'Open Settings',
                    onPress: () => Linking.openSettings(),
                    style: 'cancel',
                },
            ], {
                cancelable: true,
                onDismiss: () => Alert.alert('This alert was dismissed by tapping outside of the alert dialog.'),
            });
        }
    };
    const convertToBase64 = async (path) => {
        if (RNFS) {
            try {
                const imageUri = `file://${path}`;
                const imageData = await RNFS.readFile(imageUri, 'base64');
                setLoading(false);
                await handleAction(imageData);
                console.log("FINAL BASE 64 IMAGE IS", imageData);
            }
            catch (error) {
                console.error('Error converting image to base64:', error);
            }
        }
    };
    return (React.createElement(View, { style: {
            height: metaData.heightScreen,
            backgroundColor: 'black',
            justifyContent: 'center',
            alignItems: 'center',
        } },
        cameraDevice
            && React.createElement(Camera, { ref: cameraRef, style: StyleSheet.absoluteFill, device: cameraDevice, photo: true, isActive: true }),
        isLoading && (React.createElement(ActivityIndicator, { size: 42, color: theme.colors[ColorTokens.Primary_100], style: {
                alignSelf: 'center',
                position: 'absolute',
            } })),
        React.createElement(Pressable, { style: {
                backgroundColor: 'white',
                height: 70,
                width: 70,
                borderRadius: 35,
                borderColor: 'black',
                borderWidth: 1,
                marginTop: 40,
                position: 'absolute',
                bottom: 64,
                justifyContent: 'center',
                alignItems: 'center',
            }, onPress: async () => {
                setLoading(true);
                const uri = await cameraRef.current?.takePhoto();
                convertToBase64(uri.path);
            } }),
        React.createElement(TouchableOpacity, { style: {
                position: 'absolute',
                bottom: 90,
                left: 32,
            }, hitSlop: { top: 24, left: 24, right: 24, bottom: 24 }, onPress: () => cancelAction && triggerAction(cancelAction) },
            React.createElement(Typography, { label: 'Cancel', color: ColorTokens.White, fontSize: FontSizeTokens.LG }))));
};
export default CameraPicker;
export { CameraPicker };
